import { createContext, useContext, useState, ReactNode } from 'react';

interface LoadingContextType {
    loading: boolean;
    setLoading: (error: boolean) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
    const [loading, setLoading] = useState<boolean>(false);

    return (
        <LoadingContext.Provider value={{ loading, setLoading }}>
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => {
    const context = useContext(LoadingContext);

    if (context === undefined) {
        throw new Error('Context is undefined');
    }

    return context;
};
